import React from 'react';
import { theme } from 'antd';
import { Card, Descriptions, Alert } from 'antd';

const { useToken } = theme;

const ThemeDebugger: React.FC = () => {
  const { token } = useToken();

  // 检查关键的主题token值
  const keyTokens = {
    colorPrimary: token.colorPrimary,
    colorPrimaryHover: token.colorPrimaryHover,
    colorPrimaryActive: token.colorPrimaryActive,
    colorBorder: token.colorBorder,
    colorBorderSecondary: token.colorBorderSecondary,
    borderRadius: token.borderRadius,
    controlHeight: token.controlHeight,
    colorBgContainer: token.colorBgContainer,
  };

  // 检查是否是预期的翡翠绿值
  const isEmeraldTheme = token.colorPrimary === '#10b981';

  return (
    <Card
      title="🔍 运行时主题Token检查"
      style={{ margin: '16px 0' }}
      type={isEmeraldTheme ? 'inner' : undefined}
    >
      <Alert
        message={
          isEmeraldTheme ? '✅ 翡翠绿主题已正确应用' : '❌ 翡翠绿主题未正确应用'
        }
        description={
          isEmeraldTheme
            ? `当前主色调为 ${token.colorPrimary}，符合预期的翡翠绿主题。`
            : `当前主色调为 ${token.colorPrimary}，预期应为 #10b981。`
        }
        type={isEmeraldTheme ? 'success' : 'error'}
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Descriptions title="当前主题Token值" bordered column={2} size="small">
        {Object.entries(keyTokens).map(([key, value]) => (
          <Descriptions.Item
            key={key}
            label={key}
            labelStyle={{
              fontFamily: 'Monaco, monospace',
              fontSize: '12px',
              background: key === 'colorPrimary' ? '#f0f9f0' : undefined,
            }}
            contentStyle={{
              fontFamily: 'Monaco, monospace',
              fontSize: '12px',
              color: key === 'colorPrimary' ? '#10b981' : undefined,
              fontWeight: key === 'colorPrimary' ? 'bold' : undefined,
            }}
          >
            {String(value)}
          </Descriptions.Item>
        ))}
      </Descriptions>

      <div
        style={{
          marginTop: '16px',
          padding: '12px',
          background: '#f8fafc',
          borderRadius: '6px',
        }}
      >
        <h4 style={{ margin: '0 0 8px 0', fontSize: '14px' }}>💡 调试提示</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px' }}>
          <li>如果colorPrimary不是 #10b981，说明主题配置未生效</li>
          <li>检查 EmeraldThemeProvider 是否正确包装了应用</li>
          <li>检查 emeraldTheme.ts 中的配置是否正确</li>
          <li>尝试清除浏览器缓存并重新加载页面</li>
        </ul>
      </div>
    </Card>
  );
};

export default ThemeDebugger;
